import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { datasetsActions, datasetsSelectors, datasetsTypes } from 'app-components/flux/datasets';
import { profileSelectors } from 'app-components/flux/profile';

import SettingsItems from 'containers/Settings/ChildPages/SettingsItems';

import TextField from '@mui/material/TextField';
import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { List } from 'immutable';

const dataDictionary = List([
  {
    id: 'name',
    detailsOnly: false,
    type: 'string',
    label: 'Name',
    flex: 2,
    editable: true,
    unique: false,
    component: TextField,
  },
]);

function mkItemArray(finances) {
  if (!finances) {
    return List();
  }
  let data = List();
  finances.forEach((finance) => {
    data = data.push({ id: finance.id, name: finance.name });
  });
  return data;
}

class SettingsDatasets extends PureComponent {
  render() {
    return (
      <SettingsItems
        dataDictionary={dataDictionary}
        items={this.props.datasets}
        mkImmutableItem={(data) => datasetsTypes.mkDataset({ zipcode: '00000', ...data })}
        mkItemArray={mkItemArray}
        getItems={this.props.dispatchGetDatasetsAction}
        deleteItem={this.props.dispatchDeleteDatasetAction}
        createItem={this.props.dispatchCreateDatasetsAction}
        updateItem={this.props.dispatchUpdateDatasetAction}
        title='Finances'
        underConstruction={!this.props.financesEnabled}
        titleIconName={'finances'}
      />
    );
  }
}

SettingsDatasets.propTypes = {
  datasets: PropTypes.object,
  dispatchGetDatasetsAction: PropTypes.func,
  dispatchDeleteDatasetAction: PropTypes.func,
  dispatchCreateDatasetsAction: PropTypes.func,
  dispatchUpdateDatasetAction: PropTypes.func,
  financesEnabled: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    datasets: datasetsSelectors.getDatasetsById(state),
    financesEnabled: featureFlagsSelectors.getFeatureFlags(state).get('finances'),
    profile: profileSelectors.getProfile(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchGetDatasetsAction: () => dispatch(datasetsActions.getDatasets()),
    dispatchCreateDatasetsAction: (data) => dispatch(datasetsActions.createDataset(data)),
    dispatchUpdateDatasetAction: (data) => dispatch(datasetsActions.updateDataset(data)),
    dispatchDeleteDatasetAction: (data) => dispatch(datasetsActions.deleteDataset(data)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsDatasets);
